import * as v from "valibot";
import { rpcContract } from "../rpc";

export const getAttachableLinksForEventRpcContract = rpcContract({
  name: "get-attachable-links-for-event",
  paramsSchema: v.object({
    // Always a string. For new-event creation the client sends a provisional UUID
    // that won't be found in the DB; the handler falls back to globals-only.
    event_id: v.string(),
  }),
  resultSchema: v.object({
    links: v.array(
      v.object({
        id: v.string(),
        title: v.string(),
        has_discount: v.boolean(),
        code: v.nullable(v.string()),
        event_only: v.boolean(),
      }),
    ),
  }),
});

export type GetAttachableLinksForEventParams = v.InferOutput<
  (typeof getAttachableLinksForEventRpcContract)["paramsSchema"]
>;
export type GetAttachableLinksForEventResult = v.InferOutput<
  (typeof getAttachableLinksForEventRpcContract)["resultSchema"]
>;
